import { React, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as CheckIcon } from '../../assets/task_alt.svg'

const FinalPage = (props) => {
  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'back') {
        props.setActivePage('campaignDestination')
      }
    }
    handleNav(props)
  }, [props])

  const navigate = useNavigate()
  const loading = true
  const redirectTrackers = async (event) => {
    navigate('/trackers', { state: { loading } })
  }
  return (
    <div className="mt-48 mb-6 w-full">
      <CheckIcon className="mx-auto mb-5" aria-label="Check" role="img" />
      <p className="w-full text-3xl font-medium text-[#000000] text-center mx-auto mb-10">
        {'Start exploring your dashboard'}
      </p>
      <input
        type="button"
        id="manage"
        className="bg-metrinome-green-button font-unbounded font-light text-black text-center placeholder-white uppercase text-lg block mx-auto p-1 cursor-pointer rounded-lg h-12 w-52"
        placeholder="Manage"
        value="Manage"
        onClick={redirectTrackers}
      />
    </div>
  )
}

export default FinalPage
